import { render, staticRenderFns } from "./ExpressForm.vue?vue&type=template&id=7297f6a4&scoped=true&"
import script from "./ExpressForm.vue?vue&type=script&lang=js&"
export * from "./ExpressForm.vue?vue&type=script&lang=js&"
import style0 from "./ExpressForm.vue?vue&type=style&index=0&id=7297f6a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7297f6a4",
  null
  
)

export default component.exports